__turbopack_context__.v({
  "card": "blog-grid-module__jGFTnq__card",
  "clearButton": "blog-grid-module__jGFTnq__clearButton",
  "content": "blog-grid-module__jGFTnq__content",
  "controls": "blog-grid-module__jGFTnq__controls",
  "date": "blog-grid-module__jGFTnq__date",
  "excerpt": "blog-grid-module__jGFTnq__excerpt",
  "grid": "blog-grid-module__jGFTnq__grid",
  "image": "blog-grid-module__jGFTnq__image",
  "imageWrapper": "blog-grid-module__jGFTnq__imageWrapper",
  "noResults": "blog-grid-module__jGFTnq__noResults",
  "pageButton": "blog-grid-module__jGFTnq__pageButton",
  "pagination": "blog-grid-module__jGFTnq__pagination",
  "readMore": "blog-grid-module__jGFTnq__readMore",
  "searchInput": "blog-grid-module__jGFTnq__searchInput",
  "sortSelect": "blog-grid-module__jGFTnq__sortSelect",
  "title": "blog-grid-module__jGFTnq__title",
});
